import Api from 'dash/src/services/Api';

export const fetchAppointmentTypes = async (): Promise<string[]> => {
  const { appointmentTypes: items } = await Api.getv2(`/appointments/types`);
  return items;
};
